import { useState } from 'react';

const usePagination = <T>(array: T[], itemsPerPage = 12) => {
  const [currentPage, setCurrentPage] = useState(1);

  const totalElements = array.length || 0;
  const totalPages = Math.ceil(totalElements / itemsPerPage);

  const onPageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  return {
    paginatedData: array.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage,
    ),
    currentPage,
    totalPages,
    onPageChange,
  };
};

export default usePagination;
